import gql from 'graphql-tag'

export default gql`query inscriptionMatching($subpropertyId: String!, $programId: String!, $inscription: InscriptionInput!) {
  inscriptionMatchByProgram(subpropertyId: $subpropertyId, programId: $programId, inscription: $inscription) {
    rows {
      id
      category {
        id
        name
        minBirthYear
        maxBirthYear
      }
      identDocNeeded
      additionalDoc {
        exist
        text
        requiredDocs {
          title
          file {
            name
            publicUrl
          }
        }
      }
    }
    count
  }
}`
